import { all, call, put, takeLatest } from 'redux-saga/effects';
import SDK from 'utils/sdk';
import { changeGym, listMeGyms } from './actions';

export function* listMeGymsSaga({ payload }) {
  try {
    yield put(listMeGyms.request());
    const client = yield call([SDK, 'getClient']);

    // Build parameters object, only including isLegacy if provided
    const params = {};
    if (payload?.isLegacy !== undefined) {
      params.isLegacy = payload.isLegacy;
    }

    const { data: response } = yield call(
      [client, 'locationsList'],
      Object.keys(params).length > 0 ? params : undefined
    );

    if (response.success) {
      yield put(listMeGyms.success(response.data));
    } else {
      yield put(listMeGyms.failure(response.error));
    }
  } catch (error) {
    yield put(listMeGyms.failure(error));
  } finally {
    yield put(listMeGyms.fulfill());
  }
}

export function* changeGymSaga({ payload }) {
  try {
    yield put(changeGym.request());
    yield put(changeGym.success(payload));
  } catch (error) {
    yield put(changeGym.failure(error));
  } finally {
    yield put(changeGym.fulfill());
  }
}

export default function* gymsWatcher() {
  yield all([
    takeLatest(listMeGyms.TRIGGER, listMeGymsSaga),
    takeLatest(changeGym.TRIGGER, changeGymSaga),
  ]);
}
